import { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "utils/@reduxjs/toolkit";

import { UpdateProfilePayload, UserMeData } from "../types";
import { initialState } from "./initialState";

export const profileSlice = createSlice({
  name: "profileState",
  initialState,
  reducers: {
    getProfile(state) {
      state.loading = true;
      state.error = null;
    },
    getProfileSuccess(state, action: PayloadAction<UserMeData>) {
      state.loading = false;
      state.error = null;
      state.profile = action.payload;
      state.form.fullName = action.payload.fullName;
      state.form.mobileNumber = action.payload.mobileNumber || "";
    },
    getProfileError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    setProfileFormField(
      state,
      action: PayloadAction<{ name: "fullName" | "mobileNumber"; value: string }>
    ) {
      state.form[action.payload.name] = action.payload.value;
    },
    updateProfile(
      state,
      _action: PayloadAction<{
        id: string;
        data: UpdateProfilePayload;
        callback?: () => void;
      }>
    ) {
      state.updating = true;
      state.error = null;
    },
    updateProfileSuccess(state, action: PayloadAction<UpdateProfilePayload>) {
      state.updating = false;
      state.error = null;
      if (state.profile) {
        state.profile = {
          ...state.profile,
          ...action.payload,
        };
        state.form.fullName = state.profile.fullName;
        state.form.mobileNumber = state.profile.mobileNumber || "";
      }
    },
    updateProfileError(state, action: PayloadAction<string>) {
      state.updating = false;
      state.error = action.payload;
    },
  },
});

export const { reducer, actions, name: sliceKey } = profileSlice;
